"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COUNTRY_ALPHA_3 = exports.DEFAULT_LOCALE = exports.DEFAULT_HOST = exports.HostLocaleMap = exports.CountryAlpha3 = exports.CountryName = exports.Country = exports.Host = exports.Locale = void 0;
/* eslint-disable camelcase */
var Locale;
(function (Locale) {
    Locale["nl_NL"] = "nl_NL";
    Locale["nl_BE"] = "nl_BE";
})(Locale || (exports.Locale = Locale = {}));
var Host;
(function (Host) {
    Host["nl"] = "nl";
    Host["be"] = "be";
})(Host || (exports.Host = Host = {}));
var Country;
(function (Country) {
    Country["Netherlands"] = "NL";
    Country["Belgium"] = "BE";
})(Country || (exports.Country = Country = {}));
var CountryName;
(function (CountryName) {
    CountryName["Netherlands"] = "NL";
    CountryName["Belgium"] = "BE";
})(CountryName || (exports.CountryName = CountryName = {}));
var CountryAlpha3;
(function (CountryAlpha3) {
    CountryAlpha3["NLD"] = "NLD";
    CountryAlpha3["BEL"] = "BEL";
    CountryAlpha3["DEU"] = "DEU";
})(CountryAlpha3 || (exports.CountryAlpha3 = CountryAlpha3 = {}));
exports.HostLocaleMap = {
    [Host.nl]: Locale.nl_NL,
    [Host.be]: Locale.nl_BE,
};
exports.DEFAULT_HOST = Host.nl;
exports.DEFAULT_LOCALE = Locale.nl_NL;
exports.DEFAULT_COUNTRY_ALPHA_3 = CountryAlpha3.NLD;
